import { cacheEnableUrls, longTermCacheUrls } from './regex'
import EventBus from './eventBus'
class HttpCache {
  constructor () {
    this.cache = new Map()
    this.enabled = false
    EventBus.on('wp-review-ended', () => {
      this.disable()
      this.clean()
    })
  }

  enable () {
    this.enabled = true
  }

  disable () {
    this.enabled = false
  }

  _checkRegex (url, regexArr) {
    return Object.values(regexArr).some(path => path.test(url))
  }

  shouldCache (url) {
    if (!this.enabled || !this._checkRegex(url, cacheEnableUrls)) return false
    const context = this.cache.get(url)
    if (context) {
      return context.isLongTermCache || !context.consumed
    }
    return true
  }

  set (url, value) {
    const context = {
      value,
      consumed: false,
      isLongTermCache: this._checkRegex(url, longTermCacheUrls),
    }
    this.cache.set(url, context)
  }

  get (url) {
    const context = this.cache.get(url)
    if (context) {
      context.consumed = true
      return context.value
    } else {
      return undefined
    }
  }

  has (url) {
    return this.cache.has(url)
  }

  remove (url) {
    this.cache.delete(url)
  }

  clean () {
    this.cache = new Map()
  }
}

export default new HttpCache()
